import type { IReportColumn } from '~/presentation/reports/common/Visualization/types';
import type { OrderByFields } from '../../types';

import { SortDescendingIcon, SortAscendingIcon } from '@shopify/polaris-icons';
import { getOrderTooltip } from '../../utils/order';
import { GTextTruncated } from '~/presentation/ui';
import { EOrderDirectionType } from '../../types';
import { Box, Icon } from '@shopify/polaris';

interface ISortableHeaderProps {
  item: IReportColumn;
  orderBy?: OrderByFields;
  itemHovering?: string;
  onChangeOrderBy?: (field: string) => void;
}

export const SortableHeader = ({
  item,
  orderBy,
  itemHovering,
  onChangeOrderBy,
}: ISortableHeaderProps) => {
  const { displayName, name } = item;

  function getTooltipInfo(name: string) {
    const orderByField = orderBy?.[name];
    const content = getOrderTooltip(name, orderByField?.direction || EOrderDirectionType.ASC);
    return { content };
  }

  function getOpacity(name: string) {
    return itemHovering === name ? '1' : '0';
  }

  function getOrderIcon(name: string) {
    const orderByField = orderBy?.[name];
    if (!orderByField) return SortAscendingIcon;
    return orderByField.direction === EOrderDirectionType.ASC
      ? SortAscendingIcon
      : SortDescendingIcon;
  }

  return (
    <button className="GReportTable-SortableHeaderButton" onClick={() => onChangeOrderBy?.(name)}>
      <div className="min-w-0">
        <GTextTruncated
          as="p"
          variant="bodySm"
          fontWeight="medium"
          tone="subdued"
          tooltip={getTooltipInfo(name)}
        >
          {displayName}
        </GTextTruncated>
      </div>

      <Box opacity={getOpacity(name)}>
        <Icon source={getOrderIcon(name)} />
      </Box>
    </button>
  );
};
